const LOAD_DEVICE_EVENTS_V3_FETCH = "device-events::v3::fetch";
const LOAD_DEVICE_EVENTS_V3_SUCCESS = "device-events::v3::fetch::success";
const UNLOAD_DEVICE_EVENTS_V3 = "device-events::v3::unload";

const unloadDeviceEventsV3Action = {
  type: UNLOAD_DEVICE_EVENTS_V3,
};

export {
  LOAD_DEVICE_EVENTS_V3_FETCH,
  LOAD_DEVICE_EVENTS_V3_SUCCESS,
  UNLOAD_DEVICE_EVENTS_V3,
  unloadDeviceEventsV3Action,
};
